// extracted by mini-css-extract-plugin
export var surveyCounter = "survey-counter-module--survey-counter--GAe4b";
export var surveyCounter__content = "survey-counter-module--survey-counter__content--lm5dG";
export var surveyCounter__content__counter = "survey-counter-module--survey-counter__content__counter--Um2im";
export var surveyCounter__content__title = "survey-counter-module--survey-counter__content__title--148k4";
export var surveyCounter__iconWrapper = "survey-counter-module--survey-counter__icon-wrapper--yHYmo";